import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0efd212a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, "Top 10 " + _toDisplayString(_ctx.title.toUpperCase()), 1),
    (_ctx.title === 'artists')
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name
            }, [
              _createVNode(_component_router_link, {
                class: "link",
                to: { path: `/artists/${item.id}` }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" #" + _toDisplayString(index + 1) + "- " + _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(item.view_count) + " views", 1),
                _createElementVNode("span", null, "(" + _toDisplayString(item.percentage) + "%)", 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.title === 'artworks')
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name
            }, [
              _createVNode(_component_router_link, {
                class: "link",
                to: { path: `/artworks/${item.id}` }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" #" + _toDisplayString(index + 1) + "- " + _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(item.view_count) + " views", 1),
                _createElementVNode("span", null, "(" + _toDisplayString(item.percentage) + "%)", 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.title === 'countries')
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name
            }, [
              _createElementVNode("p", null, "#" + _toDisplayString(index + 1) + "- " + _toDisplayString(item.name), 1),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(item.view_count) + " views", 1),
                _createElementVNode("span", null, "(" + _toDisplayString(item.percentage) + "%)", 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}